import React, { useContext, useEffect, useState } from "react";
import {
  Select,
  DatePicker,
  Space,
  Button,
  Card,
  Tooltip,
  Row,
  Grid,
} from "antd";
import DataContext from "../../context/DataContext";
import { useParams } from "react-router-dom";
import { FilesTable, FileUploadModal } from "../../components/customer";
import { ColumnComponent } from "../../components/ui";
import { UploadOutlined } from "@ant-design/icons";
import { filterOption } from "../../utils/func/utils";
import { Dayjs } from "dayjs";

const { RangePicker } = DatePicker;

export const FileManagerPage: React.FC = () => {
  const { useBreakpoint } = Grid;
  const { xs } = useBreakpoint();
  const { idClient } = useParams();
  const {
    files,
    usersList,
    projectList,
    customerByClient,
    dataLoading,
    getData,
    getCustomersListByClient,
  } = useContext(DataContext);
  const [filterUser, setFilterUser] = useState<string | undefined>();
  const [filterProject, setFilterProject] = useState<string | undefined>();
  const [filterCustomer, setFilterCustomer] = useState<string | undefined>();
  const [filterDateRange, setFilterDateRange] = useState<[Dayjs, Dayjs] | null>(
    null,
  );
  const [isModalFileUploadVisible, setIsModalFileUploadVisible] =
    useState(false);
  const [filesFilter, setFilesFilter] = useState<any>({
    active: true,
    search: undefined,
  });

  useEffect(() => {
    if (idClient) {
      getData("files", idClient);
      getCustomersListByClient({ idClient });
      getData("projects", idClient);
      getData("users", idClient);
    }
  }, [idClient]);

  useEffect(() => {
    let { search, ...filters } = filesFilter;
    idClient &&
      idClient !== "" &&
      getData("files", idClient, search, filters, false);
  }, [filesFilter, idClient]);

  useEffect(() => {
    if (filterUser) {
      setFilesFilter((prev: any) => ({
        ...prev,
        uploadedBy: filterUser,
      }));
    } else {
      setFilesFilter((prev: any) => ({
        ...prev,
        uploadedBy: undefined,
      }));
    }
    if (filterProject) {
      setFilesFilter((prev: any) => ({
        ...prev,
        project: filterProject,
      }));
    } else {
      setFilesFilter((prev: any) => ({
        ...prev,
        project: undefined,
      }));
    }
    if (filterCustomer) {
      setFilesFilter((prev: any) => ({
        ...prev,
        customer: filterCustomer,
      }));
    } else {
      setFilesFilter((prev: any) => ({
        ...prev,
        customer: undefined,
      }));
    }
    if (filterDateRange) {
      const [start, end] = filterDateRange;
      setFilesFilter((prev: any) => ({
        ...prev,
        uploadDate: {
          $gte: start.toISOString(),
          $lte: end.toISOString(),
        },
      }));
    } else {
      setFilesFilter((prev: any) => ({
        ...prev,
        uploadDate: undefined,
      }));
    }
  }, [filterUser, filterProject, filterCustomer, filterDateRange]);

  return (
    <>
      <Row gutter={[24, 0]}>
        <ColumnComponent>
          <Card
            className="summary-client__card"
            styles={{ body: { display: "none" } }}
            actions={[
              <Space direction="vertical" size={0} style={{ width: "100%" }}>
                <label>Users</label>
                <Tooltip title="Filter By User">
                  <Select
                    filterOption={filterOption}
                    showSearch
                    placeholder="Filter by User"
                    style={{ width: "90%" }}
                    onChange={setFilterUser}
                    allowClear
                    options={usersList.map((user) => ({
                      label: user.name,
                      value: user._id,
                    }))}
                  ></Select>
                </Tooltip>
              </Space>,
              <Space direction="vertical" size={0} style={{ width: "100%" }}>
                <label>Projects</label>
                <Select
                  filterOption={filterOption}
                  showSearch
                  placeholder="Filter by Project"
                  style={{ width: "90%" }}
                  onChange={setFilterProject}
                  allowClear
                  options={projectList.map((project) => ({
                    label: project.name,
                    value: project._id,
                  }))}
                ></Select>
              </Space>,
              <Space direction="vertical" size={0} style={{ width: "100%" }}>
                <label>Customers</label>
                <Select
                  filterOption={filterOption}
                  showSearch
                  placeholder="Filter by Customer"
                  style={{ width: "90%" }}
                  onChange={setFilterCustomer}
                  allowClear
                  options={customerByClient.map((customer) => ({
                    label: customer.DisplayName,
                    value: customer._id,
                  }))}
                ></Select>
              </Space>,
              <Space direction="vertical" size={0} style={{ width: "100%" }}>
                <label>Filter By Date</label>
                <RangePicker
                  style={{ width: "90%" }}
                  format="MM/DD/YYYY"
                  allowClear
                  onChange={(range) =>
                    setFilterDateRange(range as [Dayjs, Dayjs])
                  }
                  popupStyle={{
                    position: "fixed",
                    top: xs ? 50 : "20vh",
                    left: xs ? 20 : "50vw",
                    minWidth: "220px",
                    maxWidth: "95vw",
                    width: "100%",
                    textOverflow: "ellipsis",
                    whiteSpace: "nowrap",
                  }}
                />
              </Space>,
              <Space direction="vertical" size={0} style={{ width: "100%" }}>
                <label>Actions</label>
                <Space direction="horizontal" size={0}>
                  <Tooltip title="Upload File" placement="bottom">
                    <Button
                      type="link"
                      icon={<UploadOutlined />}
                      loading={dataLoading}
                      onClick={() => setIsModalFileUploadVisible(true)}
                    ></Button>
                  </Tooltip>
                </Space>
              </Space>,
            ]}
          ></Card>
        </ColumnComponent>
        <ColumnComponent>
          <FilesTable
            idClient={idClient || ""}
            files={files}
            onChangePage={(current, pageSize) => {
              setFilesFilter((prev: any) => ({
                ...prev,
                page: current,
                perPage: pageSize,
              }));
            }}
          />
        </ColumnComponent>
      </Row>
      <FileUploadModal
        open={isModalFileUploadVisible}
        idClient={idClient || ""}
        onClose={() => setIsModalFileUploadVisible(false)}
        onUploadSuccess={() => idClient && getData("files", idClient)}
      />
    </>
  );
};
